// Durum rozeti — Aktif/Pasif/Taslak/Onaylı vb.
import React from 'react';

const PRESETS = {
  active:    { fg: 'var(--success)',  bg: 'rgba(22,163,74,0.12)',  label: '● Aktif' },
  inactive:  { fg: 'var(--text-tertiary)', bg: 'var(--bg-secondary)',label: '○ Pasif' },
  draft:     { fg: 'var(--warning)',  bg: 'rgba(245,158,11,0.12)', label: 'Taslak' },
  approved:  { fg: 'var(--success)',  bg: 'rgba(22,163,74,0.12)',  label: 'Onaylı' },
  pending:   { fg: 'var(--warning)',  bg: 'rgba(245,158,11,0.12)', label: 'Bekliyor' },
  cancelled: { fg: 'var(--danger)',   bg: 'rgba(220,38,38,0.12)',  label: 'İptal' },
  sent:      { fg: 'var(--info)',     bg: 'rgba(59,130,246,0.12)', label: 'Gönderildi' },
};

export default function CardStatusBadge({ preset, label, color, bg }) {
  const p = (preset && PRESETS[preset]) || {};
  return (
    <span style={{
      fontSize: '0.72rem',
      padding: '4px 10px',
      borderRadius: 'var(--r-full)',
      fontWeight: 700,
      whiteSpace: 'nowrap',
      background: bg || p.bg || 'var(--bg-secondary)',
      color: color || p.fg || 'var(--text-secondary)',
    }}>{label || p.label || preset}</span>
  );
}
